export default {
  dashboard: 'Dashboard',
  orders: 'Pesanan',
  newOrderNavTitle: 'Ada pesanan baru',
  reports: 'Laporan',
  shippingProblem: 'Masalah Pengiriman',
  damageOrMissing: 'Kerusakan/Selisih',
  schedule: 'Jadwal',
  invoice: 'Invoice',
  masterData: 'Master Data',
  transport: 'Kendaraan',
  userAdmin: 'User Admin',
  invoiceData: 'Invoice Data',
  driver: 'Sopir',
  aboutUs: 'Tentang Kami',
  contactUs: 'Hubungi Kami',
  logout: 'Logout',
  reporting: 'Dokumen',
  documentReport: 'Laporan', 
  taxReport: 'Pajak'
}
